import { useEffect, useRef, useState, type MouseEvent } from 'react';
import { Icon } from '../../../assets/icons/icons';
import { useToast } from '../../ui/Toast/ToastProvider';
import { copyText } from '../../../utils/format';
import { cx } from '../../../utils/cx';
import styles from './CopyIdButton.module.scss';
import React from 'react';

export interface CopyIdButtonProps {
    id: string;
    /** В таблице кнопка появляется только при наведении на строку. */
    onlyOnHover?: boolean;
}

export function CopyIdButton({ id, onlyOnHover = false }: CopyIdButtonProps) {
    const [copied, setCopied] = useState(false);
    const timer = useRef<number | undefined>(undefined);
    const toast = useToast();

    useEffect(() => () => window.clearTimeout(timer.current), []);

    const handle = async (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        const ok = await copyText(id);
        toast(ok ? 'ID скопирован' : 'Не удалось скопировать: браузер запретил доступ к буферу');
        if (!ok) return;
        setCopied(true);
        window.clearTimeout(timer.current);
        timer.current = window.setTimeout(() => setCopied(false), 1200);
    };

    return (
        <button
            type="button"
            className={cx(styles.copy, onlyOnHover && styles.hoverOnly, copied && styles.done)}
            onClick={handle}
            aria-label="Скопировать ID обращения"
        >
            <Icon name={copied ? 'check' : 'copy'} size={12} />
        </button>
    );
}
